import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class PhoneTypeService {
  constructor(private coreServie: CoreService) {}

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreServie.get(
      ServiceRoute.phoneType.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
}
